<template>
  <div v-if="detailDevisCommande" class="is-marginless is-paddingless section section-details">
    <div class="pdt-20px">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detail.titleCommand') }} n°: {{ detailDevisCommande.code }}</h1>
              <tag-list
                  class="mgb-0"
                  v-if="commandeTags.length > 0"
                  :listes="commandeTags"/>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right" v-if="canSeeCommande">
          <div class="buttons">
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              v-if="isNotClosOrSansSuite && activeButtonEtLien"
              :permission="permCommandes.maj"
              :actions="insertActionSecondary"
              @click="() => {
                $router.push({ name: 'm.bodac.commandes', params: {id: $route.params.id}});
              }">
                {{ $t('detail.buttons.edit') }}&nbsp;
            </dropdownButton>
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              v-if="peutEtreFacturer && hasProspect && activeButtonEtLien"
              :permission="permFactures.maj"
              :actions="actionFacture"
              @click="() => {
                onClickFacture();
              }">
                {{ $t('detail.buttons.facturer') }}&nbsp;
            </dropdownButton>
            <button class="button is-addOrEdit" type=""
                    v-if="isReactive && activeButtonEtLien"
                    @click="openPopUpDecloture = true">
              {{ $t('detail.buttons.decloturerCommande') }}
            </button>
            <button class="button" v-if="activeButtonEtLien"
                    @click="openPopUpDuplicate = true">
              <b-icon icon="file-multiple" type="is-default"></b-icon>
            </button>
            <mail-button
              class="mgr-2"
              :perm="permCommandes.lecture"
              :titlePopUp="'detailCommande.popUpMail.title'"
              :dcfDetail="detailDevisCommande"
              :editionsAInclure="editionsAInclure"
              :mailSetUp="mailSetUp">
            </mail-button>
            <b-tooltip
              :active="!!isSignable.length"
              position="is-left">
              <template v-slot:content>
                <div v-for="(msg,i) in isSignable" :key="i">
                  <p>{{msg}}</p>
                </div>
              </template>
              <button class="button mgr-2"
                v-if="moduleSignatureElectroniqueActive  && activeButtonEtLien"
                :class="{ 'button-access-no-permission' : !checkPermissions(permCommandes.maj)}"
                :disabled="!!isSignable.length"
                @click="checkPermissions(permCommandes.maj)
                  ? popUpEnvoieDemandeSignature = true : showPopUp()">
                <b-icon
                  icon="signature-freehand"
                  type="is-default">
                </b-icon>
              </button>
            </b-tooltip>
            <b-tooltip
              :active="hasStopSignatureEnCours"
              :label="$t('detail.buttons.stopSignature')"
              position="is-left">
              <button class="button mgr-2"
                v-if="activeButtonEtLien && hasStopSignatureEnCours"
                @click="closeDemandeSignature">
                <b-icon icon="hand-back-left-outline" type="is-default"></b-icon>
              </button>
            </b-tooltip>
            <button class="button">
              <b-dropdown position="is-bottom-left">
                <b-icon icon="dots-vertical" slot="trigger" role="button" type="is-default"/>
                <b-dropdown-item
                  v-if="estCommandeTempo"
                  @click="checkPermissions(permCommandes.exporter)
                  ? exporterListeFacesVenduesReseauTempo() : showPopUp()">
                  {{ $t('detail.buttons.exporterListeFacesVenduesReseauTempo') }}
                </b-dropdown-item>
                <b-dropdown-item v-if="devisCommande"
                 @click="checkPermissions(permCommandes.exporter)
                  ? exporterLigneVente() : showPopUp()">
                  {{ $t('detail.buttons.exporterLignesVentes') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <button class="button"
                    @click="$refs.dropdownEdition.toggle()">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown
                  ref="dropdownEdition"
                  position="is-bottom-left"
                  class="has-text-left">
                  <div slot="trigger">
                    <b-icon
                      icon="chevron-down"
                      class="has-text-secondary-icon">
                    </b-icon>
                  </div>
                  <b-dropdown-item
                    @click="checkPermissions(permCommandes.editer)
                    ? edition({format: constantes.pdf,
                    typeDonnee: constantes.typeEditionCommande}) : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permCommandes.editer)
                    ? edition({format: constantes.docx,
                    typeDonnee: constantes.typeEditionCommande}) : showPopUp()">
                    {{ $t('general.popUpEdition.type.docx') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permCommandes.editer)
                    ? showPdfViewer = true : showPopUp()">
                    {{ $t('general.previsualisation') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permCommandes.editer) ?
                popUpEdition = true : showPopUp()">
                    {{ $t('general.popUpEdition.type.other') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
            <button class="button" v-if="activeButtonEtLien">
              <b-dropdown position="is-bottom-left" aria-role="list" class="has-text-left">
                <a slot="trigger">
                  <b-icon class="is-flex"
                    custom-class="has-text-icon-more"
                    icon="call-split">
                  </b-icon>
                </a>
                <b-dropdown-item
                  @click="$router.push({ name: 'l.bodac.commandes-renouvellement' })">
                  {{ $t('detail.buttons.aRenouveler') }}
                </b-dropdown-item>
                <b-dropdown-item has-link>
                  <router-link-blank
                    classComposant="noTextDecoration"
                    classMessage="is-block"
                    :to="{ name: 'l.bodac.factures-liaison-commande',
                    params: { commandeId: devisCommande.id } }"
                    :message="$t('detail.buttons.factureAvoir')"></router-link-blank>
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <piece-jointe-button
              v-if="activeButtonEtLien"
              class="mgr-2"
              :perm="permCommandes.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div v-if="canSeeCommande && !activeButtonEtLien">
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('detail.infos.commande') }]"
                                       :canClose="false"
        >
        </app-information-msg-component>
      </div>
      <div class="tab" v-if="canSeeCommande">
        <ul>
          <li :class="{'is-active': activeTab === 'AppDetailCommande'}"
              @click="setActiveTabCommandeDetail()">
            {{ $t('detailCommande.tabs.detail') }}
          </li>
          <li :class="{'is-active': activeTab === 'logistique'}"
              @click="activeTab = 'logistique'">
            <b-field>
              <div class="mgv-auto mgr-5px round-circle-warning"
                   v-if="displayRoundAlerteLogistique"></div>
              <div class="mgr-5px" v-else></div>
              <span>{{ $t('detailCommande.tabs.logistique') }}</span>
            </b-field>
          </li>
          <li :class="{'is-active': activeTab === 'echeancierFacturation'}"
              @click="activeTab = 'echeancierFacturation'">
            {{ $t('detailCommande.tabs.echeancierFacturation') }}
          </li>
          <li :class="{ 'is-active': activeTab === 'achatVenteInterne' }"
              @click="activeTab = 'achatVenteInterne'"
              v-if="siteHasHolding">
            <b-field>
              <div class="mgv-auto mgr-5px"
                   :class="getColorStatuCommandeAchat"></div>
              <span> {{ $t('detailCommande.tabs.achatVenteInterne') }} </span>
            </b-field>
          </li>
          <li :class="{ 'is-active': activeTab === 'detailAchatCommande' }"
              @click="activeTab = 'detailAchatCommande'"
              v-if="devisCommande.role !== constantes.REGIE">
            {{ $t('editionCommande.tabs.achat') }}
          </li>
          <li :class="{'is-active': activeTab === 'previsualisation'}"
              @click="activeTab = 'previsualisation'">
            {{ $t('detailCommande.tabs.previsualisation') }}
          </li>
          <li :class="{'is-active': activeTab === 'commissionsCommande'}"
              @click="activeTab = 'commissionsCommande'" v-if="modulePresseActive">
            {{ $t('detailCommande.tabs.commissions') }}
          </li>
          <li :class="{'is-active': activeTab === 'commissionsFournisseur'}"
              v-if="modulePresseActive"
              @click="activeTab = 'commissionsFournisseur'">
            {{ $t('detail.ongletFacture.commissionFournisseur') }}
          </li>
          <li :class="{'is-active': activeTab === 'etatSuiviDevisCommande'}"
              @click="activeTab = 'etatSuiviDevisCommande'" v-if="modulePresseActive">
            {{ $t('detailCommande.tabs.etatSuiviDevisCommande') }}
          </li>
          <li :class="{'is-active': activeTab === 'signatureElectroniqueHisto'}"
            @click="activeTab = 'signatureElectroniqueHisto'"
            v-if="moduleSignatureElectroniqueActive">
            {{ $t('detailCommande.tabs.signatureElectroniqueHisto') }}
          </li>
          <li
            v-if="moduleLogistiqueImpressionActive"
            @click="checkPermissions(permBesoins.maj)
              ? activeTab = 'logistiqueImpression'
              : showPopUp()"
            :class="{
              'is-active': activeTab === 'logistiqueImpression',
              'text-access-no-permission' : !checkPermissions(permBesoins.maj),
            }">
            {{ $t('detailCommande.tabs.logistiqueImpression') }}
          </li>
          <li :class="{'is-active': activeTab === 'commandeAchat'}"
              @click="activeTab = 'commandeAchat'"
              v-if="moduleLogistiqueImpressionActive || moduleAchatActive">
            {{ $t('editionCommande.tabs.achat') }}
          </li>
          <li :class="{'is-active': activeTab === 'lignesCommandeAchatTab'}"
            @click="activeTab = 'lignesCommandeAchatTab'"
            v-if="moduleLogistiqueImpressionActive || moduleAchatActive">
            {{ $t('detailCommande.tabs.lignesCommandeAchat') }}
          </li>
        </ul>
      </div>
      <div v-else>
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('general.noAccess') }]"
                                       :canClose="false"
        >
        </app-information-msg-component>
      </div>
    </div>
    <component
      v-if="canSeeCommande"
      v-model="devisCommande"
      :is="activeTab"
      :dcf="devisCommande"
      :isEdit="false"
      :ordresTravails="ordresTravails"
      :commande="devisCommande"
      :detailCommande="detailDevisCommande"
      :detailDevisCommande="detailDevisCommande"
      :commandesAchat="commandesAchat"
      :payeurSelected="payeurSelected"
      :toolTipSignatureInfo="toolTipSignatureInfo"
      @reloadCommandeAchat="loadCommandeAchat"
      ref='loadFromChild'/>
    <b-modal v-model="deleteCommand"
             has-modal-card
             class="modal">
      <confirmation-suppression-commande
        :devisCommandes="commandASupp"
        @rechargement="rechargementSuiteSuppression()"
        :type="type"/>
    </b-modal>
    <b-modal v-model="isComponentselectionEcheance"
             has-modal-card
             class="modal" >
      <selection-echeance :codeCommande="detailDevisCommande.code"
                          :intervenants="devisCommande.intervenants"
                          :echeanciers="devisCommande.echeanciers"
                          :ligneCommandes="devisCommande.lignesCommande"
                          @closeWithReload="closeBillWithReload">
      </selection-echeance>
    </b-modal>
    <b-modal v-model="showPopupCloture"
             has-modal-card
             class="modal"
             width="25vw">
      <popup-cloture
        @close="showPopupCloture = false;"
        @cloture="cloture"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'>
      </popup-cloture>
    </b-modal>
    <b-modal v-model="popUpAcompte" has-modal-card class="modal" v-if="detailDevisCommande">
      <app-pop-up-acompte :devisCommande="detailDevisCommande"
                          :type="devisCommande.type"
      ></app-pop-up-acompte>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :choiceEdition="choiceEdition"
        :error="errorEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="popUpSansSuite" has-modal-card class="modal">
      <app-pop-up-sans-suite
        :messHeader="$i18n.t('detail.popUpSansSuite.messCommande')"
        :cancel="$i18n.t('detail.popUpSansSuite.cancel')"
        :validate="$i18n.t('detail.popUpSansSuite.sansSuite')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        oncancel="popUpSansSuite = false"
        @no="popUpSansSuite = false"
        @yes="classerSansSuite()">
      </app-pop-up-sans-suite>
    </b-modal>
    <b-modal v-model="openPopUpDuplicate" has-modal-card class="modal">
      <pop-up-duplicate :title="$t('detailCommande.dupliquer.title', { code: devisCommande.code })"
                        :date="devisCommande.datePremierAffichage"
                        @dupliquer="copy">
      </pop-up-duplicate>
    </b-modal>
    <b-modal v-model="popUpMotifNonRenouvellement" has-modal-card class="modal">
      <pop-up-motif-non-renouvellement :commande-ids="[devisCommande.id]"
                                       @recherche="$router.go(0)"
      ></pop-up-motif-non-renouvellement>
    </b-modal>
    <b-modal v-model="openPopUpDecloture" has-modal-card class="modal">
      <app-pop-up-sans-suite
        :messHeader="$i18n.t('detailCommande.popUpDeCloture.mess')"
        :cancel="$i18n.t('general.non')"
        :validate="$i18n.t('general.oui')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        @no="openPopUpDecloture = false"
        @yes="decloturerCommande()">
      </app-pop-up-sans-suite>
    </b-modal>
    <b-modal v-model="popUpEnvoieDemandeSignature" has-modal-card class="modal">
      <pop-up-envoie-demande-signature
        :devisCommande="devisCommande">
      </pop-up-envoie-demande-signature>
    </b-modal>
    <b-modal
      v-model="popUpIndexationCommande"
      class="modal"
      has-modal-card>
      <indexation-pop-up
        :commande="devisCommande"
        @close="popUpIndexationCommande = false"
        @reload="load"
      />
    </b-modal>
    <transition
      name="custom-classes-transition"
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight"
      :duration="900">
      <pdf-viewer
        v-if="showPdfViewer"
        :payload-edition="{
          ids: [devisCommande.id],
          typeDonnee: constantes.typeEditionCommande,
        }"
        @closed="showPdfViewer = false"
      />
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import edition from '@/api/edition/index';
import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import {
  get, sansSuite,
  cloture, retourEnAttente,
  enCoursRenouvellement,
  reactiverCommande, annulationIndexation,
} from '@/api/commande/index';
import dropdownButton from '@/components/general/button/dropdownButton';
import { getAll } from '@/api/logistique/demandeLogistique/index';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import * as devisConf from '@/configuration/devisConf';
import confirmationSuppressionCommande from '@/components/devisCommandes/confirmationSuppressionCommande';
import SelectionEcheance from '@/components/devisCommandes/selectionEcheances';
import AppPopUpAcompte from '@/components/devisCommandes/detailDevisCommande/popUpAcompte';
import { COMMANDES, FACTURES, BESOIN } from '@/configuration/permissionsBodacConf';
import AppPopUpSansSuite from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import validationSansSuite from '@/services/devisCommandes/validation/validationSansSuite';
import validationCloture from '@/services/devisCommandes/validation/validationCloture';
import validationAnnulationCommission from '@/services/devisCommandes/validation/validationAnnulationCommission';
import formatDate from '@/services/general/formatIsoDate';
import popupCloture from '@/components/devisCommandes/detailDevisCommande/popupCloture';
import * as typesCommande from '@/store/modules/commande-mutation-type';
import genererCopyDevisCommande from '@/services/devisCommandes/genererCopyDevisCommande';
import {
  LISTE_CHOICE_EDITION_COMMANDE,
  TYPE_EDITION_CMD,
  TYPE_EDITION_COMMANDE_MAIL,
  EXPORT_EXCEL_LIGNE_COMMANDE,
} from '@/configuration/commande/commandeConf';
import AppDetailCommande from '@/components/devisCommandes/detailDevisCommande/informationsGeneralesCommande';
import previsualisation
  from '@/components/devisCommandeFacture/previsualisation/previsualisation';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import logistique from '@/components/commande/logistique/logistiqueOngletDetail';
import { getOdresTravailsOfCommande } from '@/api/logistique/ordreTravailAffichage';
import { COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import snackBarSuccess from '@/services/general/snackbar/snackBarSuccess';
import detailAchatCommande from '@/components/devisCommandes/achat/detailAchatCommande';
import { REGIE } from '@/configuration/societe/societe';
import popUpMotifNonRenouvellement from '@/components/commande/renouvellement/popUpMotifNonRenouvellement';
import popUpEdition from '@/components/factures/p_edition';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationGeneral from '@/services/validation/validation';
import validationIndexation from '@/services/devisCommandes/validation/validationIndexationCommande';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import * as renouvellementReconduction from '@/services/bodac/commande/renouvellementReconduction/renouvellementReconduction';
import { CATEGORIE_REGROUPEMENT, CATEGORIE_UNITAIRE, TYPE_DONNEE_DIAPORAMA } from '@/configuration/catalogue/produitConf';
import updateInfoLogistiqueLigneCmd from '@/services/bodac/commande/ligneCommande/updateInfoLogistiqueLigneCmd';
import multiActionLogistiqueGetter from '@/services/logistique/demandeLogistique/multiActionLogistiqueGetter';
import popUpDuplicate from '@/components/commande/detail/p_duplicate';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { siteHasHolding } from '@/services/general/holding';
import achatVenteInterne from '@/components/commande/detail/achatVenteInterne';
import loadCommandeAchatVenteInterne
  from '@/services/commande/commandeAchat/loadCommandeAchatVenteInterne';
import cloneDeep from 'lodash/cloneDeep';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';
import exportListeFaceVenduInCommandeTempo from '@/services/excel/exportFaceVendueInCommandeTempo/exportListeFaceVenduInCommandeTempo';
import i18n from '@/i18n';
import { getLignesSelectionFace } from '@/services/dcf/reseauTempo/getListeFacesForSelection';
import { getAll as getAllOtTechnique } from '@/api/logistique/ordreTravailTech';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import commissionsCommande
  from '@/components/devisCommandes/detailDevisCommande/commissionsCommande';
import commissionsFournisseur from '@/components/factures/detail/commissionsFournisseur';
import echeancierFacturation from '@/components/devisCommandes/detailDevisCommande/echeancierFacturation';
import etatSuiviDevisCommande from '@/components/devisCommandes/presse/etatSuiviDevisCommande/etatSuiviDevisCommande';
import mailButton from '@/components/general/button/mailButton';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import signatureElectroniqueHisto from '@/components/devisCommandes/detailDevisCommande/signatureElectroniqueHisto';
import { getAll as getAllSignatures, stopActionSignature } from '@/api/signatureElectronique';
import getInfosSignaturePourDevisCommande from '@/services/signatureElectronique/getInfosSignaturePourDevisCommande';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { OPENNED } from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import checkSiCommandeSignable from '@/services/devisCommandes/signatureElectronique/checkSiCommandeSignable';
import popUpEnvoieDemandeSignature from '@/components/devisCommandes/detailDevisCommande/popUpEnvoieDemandeSignature';
import exportExcel from '@/api/exportExcel';
import pdfViewer from '@/components/general/pdfViewer';
import IndexationPopUp from '@/components/bodac/dcf/indexation/indexationCommandePopUp';
import * as interventionConf from '@/configuration/logistique/intervention/interventionConf';
import tagList from '@/components/general/tagList';
import LogistiqueImpression from '@/components/commande/logistiqueImpression/logistiqueImpressionTab';
import commandeAchat from '@/components/commande/detail/commandeAchat/commandeAchat';
import lignesCommandeAchatTab from '@/components/commande/detail/ligneCommandeAchat/lignesCommandeAchat';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const Commandes = createNamespacedHelpers('commande');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    dropdownButton,
    AppBreadcrumb,
    confirmationSuppressionCommande,
    SelectionEcheance,
    AppPopUpAcompte,
    AppPopUpSansSuite,
    popupCloture,
    AppDetailCommande,
    previsualisation,
    routerLinkBlank,
    logistique,
    AppInformationMsgComponent,
    detailAchatCommande,
    popUpMotifNonRenouvellement,
    popUpEdition,
    mailButton,
    popUpDuplicate,
    achatVenteInterne,
    commissionsCommande,
    commissionsFournisseur,
    echeancierFacturation,
    etatSuiviDevisCommande,
    pieceJointeButton,
    signatureElectroniqueHisto,
    errorMsgComponent,
    popUpEnvoieDemandeSignature,
    pdfViewer,
    IndexationPopUp,
    tagList,
    LogistiqueImpression,
    commandeAchat,
    lignesCommandeAchatTab,
  },
  data() {
    return {
      isErrorPopup: false,
      messagesPopup: [],
      popUpSansSuite: false,
      error: false,
      detailDevisCommande: null,
      devisCommande: null,
      isComponentselectionEcheance: false,
      showPopupCloture: false,
      payeurSelected: null,
      deleteCommand: false,
      commandASupp: [],
      type: devisConf.TYPE_COMMANDE,
      popUpAcompte: false,
      permCommandes: COMMANDES,
      permFactures: FACTURES,
      permBesoins: BESOIN,
      activeTab: 'AppDetailCommande',
      ordresTravails: [],
      etatArenouveler: devisConf.ETAT_ENATTENTE,
      etatNonRenouvelee: devisConf.ETAT_NONRENOUVELEE,
      etatRenouvelee: devisConf.ETAT_RENOUVELEE,
      etatTacite: devisConf.ETAT_TACITE,
      popUpMotifNonRenouvellement: false,
      popUpEdition: false,
      popUpIndexationCommande: false,
      constantes: {
        ETAT_ENCOURS: devisConf.ETAT_ENCOURS,
        REGIE,
        pdf: TYPE_PDF,
        docx: TYPE_DOCX,
        typeEditionCommande: TYPE_EDITION_CMD,
        EXPORT_EXCEL_LIGNE_COMMANDE: EXPORT_EXCEL_LIGNE_COMMANDE,
      },
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      openPopUpDuplicate: false,
      openPopUpDecloture: false,
      commandesAchat: [],
      editionsAInclure: [{
        libelle: 'detailCommande.popUpMail.inclureCommande', key: 'mettreEdition', value: true, type: TYPE_EDITION_COMMANDE_MAIL,
      }],
      actionFacture: [{
        label: this.$t('detail.buttons.acompte'),
        action: () => { this.popUpAcompte = true; },
      }],
      toolTipSignatureInfo: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      isError: false,
      popUpEnvoieDemandeSignature: false,
      showPdfViewer: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
      agencesSelectionnees: 'agenceActive',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
      site: 'site',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    mailSetUp() {
      return {
        objet: this.$i18n.t('detailCommande.popUpMail.commandeObject', {
          code: this.detailDevisCommande.code,
          date: this.detailDevisCommande.generalInfos.dateDevisCommande,
        }),
        contactDCFTitle: this.$t('detailCommande.popUpMail.contactTitle'),
      };
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleLogistiqueTechnique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    paramDimensionExportDcfCbaSpe() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.dimensionExportDcfCbaSpe.key);
    },
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
    getColorStatuCommandeAchat() {
      if (this.commandesAchat.length === 0) return '';
      const statusVenteInterne = [...new Set(this.commandesAchat
        .filter(c => c.commandeVenteInterne)
        .map(c => c.commandeVenteInterne.etat))];
      const status = [...new Set(this.commandesAchat.map(c => c.etat))];
      if (status.length > 1 || statusVenteInterne > 1 || (status[0] !== statusVenteInterne[0])) return 'round-circle-warning';
      return status[0] === devisConf.ETAT_BROUILLON || statusVenteInterne[0] === devisConf.ETAT_BROUILLON ? 'round-circle-danger' : 'round-circle-success';
    },
    siteHasHolding() {
      return siteHasHolding();
    },
    choiceEdition() {
      let typeEdition = cloneDeep(LISTE_CHOICE_EDITION_COMMANDE);
      if (!this.moduleCBADiaporama) {
        typeEdition = typeEdition.filter(l => {
          return l.libelle !== 'catalogue.edition.diaporama';
        });
      }
      if (this.detailDevisCommande.lignesCommande.some(l => {
        return l.typeProduit === CATEGORIE_UNITAIRE;
      })) return typeEdition;
      return typeEdition.filter(choice => {
        return choice.libelle !== 'detail.edition.commandeDetailLc';
      });
    },
    hasProspect() {
      return this.detailDevisCommande.intervenants.some((intervenant) => {
        return intervenant.tiers.prospect;
      }) === false;
    },
    isNotClosOrSansSuite() {
      return (this.detailDevisCommande.etat !== devisConf.ETAT_CLOTURER
          && this.detailDevisCommande.etat !== devisConf.ETAT_SANSSUITE);
    },
    canMakeRenouvellement() {
      return (this.detailDevisCommande?.renouvelable
        && (this.detailDevisCommande.etat === devisConf.ETAT_FACTURE_PARTIELLEMENT
        || this.detailDevisCommande.etat === devisConf.ETAT_FACTURE
          || this.detailDevisCommande.etat === devisConf.ETAT_ENREGISTRE));
    },
    displayRoundAlerteLogistique() {
      return (this.devisCommande.lignesCommande.some((ligne) => {
        return ((ligne.typeProduit === CATEGORIE_UNITAIRE
          && ligne.datePlanifieeLogistiqueAffichage
          && !moment(ligne.datePlanifieeLogistiqueAffichage).isSame(moment(ligne.dateDebut))
          || ligne.isAffecteLogistiquement)
        );
      })) || (this.detailDevisCommande.lignesCommande.some((ligne) => {
        return multiActionLogistiqueGetter(ligne);
      }));
    },
    canSeeCommande() {
      if (!this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key)) return true;
      return ((this.user.profil === COMMERCIAL
        && this.devisCommande.commercialId === this.user.id)
        || this.user.profil !== COMMERCIAL);
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeCommandes.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeCommandes.titleCommande'), route: { name: 'l.bodac.commandes-liste' }, isActive: false },
        { title: this.$i18n.t('detail.titleCommand'), route: { name: 'c.bodac.commandes' }, isActive: true },
      ];
      return output;
    },
    peutEtreFacturer() {
      return this.detailDevisCommande
          && (this.detailDevisCommande.etat !== devisConf.ETAT_FACTURE
          && this.detailDevisCommande.etat !== devisConf.ETAT_CLOTURER
          && this.detailDevisCommande.etat !== devisConf.ETAT_SANSSUITE);
    },
    estFacture() {
      return this.detailDevisCommande
          && (this.detailDevisCommande.etat === devisConf.ETAT_FACTURE
          || this.detailDevisCommande.etat === devisConf.ETAT_FACTURE_PARTIELLEMENT);
    },
    etatEnregistre() {
      return this.detailDevisCommande
        && this.detailDevisCommande.etat === devisConf.ETAT_ENREGISTRE;
    },
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.devisCommande.societeId);
    },
    estCommandeTempo() {
      return this.devisCommande.categorieVente === CATEGORIE_REGROUPEMENT;
    },
    isReactive() {
      return this.devisCommande.sens === devisConf.SENS_VENTE
        && this.detailDevisCommande.etat === devisConf.ETAT_CLOTURER;
    },
    moduleSignatureElectroniqueActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
    moduleIndexationCommandeActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key);
    },
    moduleLogistiqueImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key);
    },
    moduleAchatActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleAchat.key);
    },
    moduleCBADiaporama() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.diaporamaCBA.key);
    },
    hasStopSignatureEnCours() {
      return this.moduleSignatureElectroniqueActive
        && this.devisCommande.signaturesHisto
          .filter(el => el.contratEtatSignature === OPENNED).length === 1;
    },
    isSignable() {
      const societe = this.societesInformations.find((s) => s.id === this.devisCommande.societeId);
      return checkSiCommandeSignable(this.devisCommande, societe);
    },
    insertActionSecondary() {
      const actionSecondary = [];
      if (this.etatEnregistre) {
        actionSecondary.push({
          label: this.$t('detail.buttons.sansSuite'),
          action: () => { this.openPopUpSansSuite(); },
          order: 1,
        });
        actionSecondary.push({
          label: this.$t('detail.buttons.delete'),
          action: () => { this.inProgress(); },
          actionPermission: COMMANDES.supprimer,
          order: 10,
        });
      }
      if (this.estFacture) {
        actionSecondary.push({
          label: this.$t('detail.buttons.cloturer'),
          action: () => { this.onClickCloture(); },
          order: 6,
        });
      }
      if (this.canMakeRenouvellement
        && (this.detailDevisCommande.etatRenouvellement === this.etatArenouveler
        || this.detailDevisCommande.etatRenouvellement === this.constantes.ETAT_ENCOURS)) {
        actionSecondary.push({
          label: this.$t('renouvellementCommande.actions.renouveler'),
          action: () => {
            this.$router.push({
              name: 'm.bodac.commandes-ajoutRenouvelOrTacite',
              params: { id: this.detailDevisCommande.id, renouveleOrTacite: this.etatRenouvelee },
            });
          },
          order: 2,
        });
        actionSecondary.push({
          label: this.$t('renouvellementCommande.actions.marquerRenouvele'),
          action: () => {
            this.marquerRenouveleReconduit([this.detailDevisCommande.id], this.etatRenouvelee);
          },
          order: 3,
        });
      }
      if ((this.detailDevisCommande.etatRenouvellement
          === this.etatNonRenouvelee
          || this.detailDevisCommande.etatRenouvellement === this.etatTacite
          || this.detailDevisCommande.etatRenouvellement === this.etatRenouvelee
          || this.detailDevisCommande.etatRenouvellement === this.constantes.ETAT_ENCOURS)
          && this.canMakeRenouvellement) {
        actionSecondary.push({
          label: this.$t('renouvellementCommande.actions.aRenouveler'),
          action: () => {
            this.changeEtatEnAttente(this.detailDevisCommande.id);
          },
          order: 4,
        });
      }
      if ((this.detailDevisCommande.etatRenouvellement === this.etatArenouveler
        || this.detailDevisCommande.etatRenouvellement === this.constantes.ETAT_ENCOURS)
        && this.canMakeRenouvellement) {
        actionSecondary.push({
          label: this.$t('renouvellementCommande.actions.pasRenouveler'),
          action: () => {
            this.popUpMotifNonRenouvellement = true;
          },
          order: 5,
        });
        actionSecondary.push({
          label: this.$t('renouvellementCommande.actions.enCours'),
          action: () => {
            this.enCoursRenouvellement();
          },
          order: 9,
        });
      }
      if (this.detailDevisCommande.reconductible
          && (this.detailDevisCommande.etatRenouvellement === this.etatArenouveler
          || this.detailDevisCommande.etatRenouvellement === this.constantes.ETAT_ENCOURS)) {
        actionSecondary.push({
          label: this.$t('renouvellementCommande.actions.reconduireTacitement'),
          action: () => {
            this.$router.push({
              name: 'm.bodac.commandes-ajoutRenouvelOrTacite',
              params: { id: this.detailDevisCommande.id, renouveleOrTacite: this.etatTacite },
            });
          },
          order: 7,
        });
        actionSecondary.push({
          label: this.$t('renouvellementCommande.actions.marquerReconduitTacitement'),
          action: () => {
            this.marquerRenouveleReconduit([this.detailDevisCommande.id], this.etatTacite);
          },
          order: 8,
        });
      }
      if (this.moduleIndexationCommandeActive && this.devisCommande.estIndexable) {
        actionSecondary.push({
          label: this.$t('detail.buttons.indexation'),
          action: () => { this.popUpIndexationCommande = true; },
          order: 11,
        });
      }
      if (this.moduleIndexationCommandeActive && this.devisCommande.estIndexable
        && this.devisCommande.valeurIndexationActuel !== null) {
        actionSecondary.push({
          label: this.$t('detail.buttons.resetIndexation'),
          action: () => { this.reinitialiserIndexation(); },
          disabled: !this.canAnnulerIndexation,
          order: 12,
        });
      }
      return actionSecondary;
    },
    flatLignesCommande() {
      return this.devisCommande?.lignesCommande.map(
        ligne => [ligne, ligne.lignesCommande.map(sousligne => sousligne)]).flat(3);
    },
    canAnnulerIndexation() {
      return this.flatLignesCommande.every(ligne => {
        const result = (!!ligne.indexation.valeurIndiceActuel
          && !!ligne.indexation.pourcentageTheorique)
          || (!ligne.indexation.valeurIndiceActuel && !ligne.indexation.pourcentageTheorique);
        return result;
      });
    },
    exportExcelQuery() {
      return {
        typeDonnee: this.constantes.EXPORT_EXCEL_LIGNE_COMMANDE,
        typeExport: null,
        filtres: {
          Query: this.lastPayload,
          sorting: 'ordre asc',
        },
      };
    },
    lastPayload() {
      return {
        ids: this.devisCommande?.lignesCommande.flatMap(
          ligne => [ligne.id, ligne.lignesCommande.map(sousligne => sousligne.id)])
          .flatMap(id => id),
      };
    },
    commandeTags() {
      return this.devisCommande?.tags?.map(t => t.tag) ?? [];
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...Commandes.mapMutations({
      setCommandeCourant: typesCommande.SET_COMMANDE,
    }),
    async setActiveTabCommandeDetail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.detailDevisCommande.id) {
          await this.setAttachmentContext({ module: 'Commande' });
          await this.setAttachmentElementId({ id: this.detailDevisCommande.id });
        }
        this.activeTab = 'AppDetailCommande';
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async enCoursRenouvellement() {
      const loadingComponent = this.$buefy.loading.open();
      const params = {
        devisCommandeIds: [this.detailDevisCommande.id],
      };
      try {
        await enCoursRenouvellement(params);
        loadingComponent.close();
        messageSucces(this.$i18n.t('renouvellementCommande.messages.success.changeEtatEnCours'));
        this.$router.go(0);
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async decloturerCommande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await reactiverCommande(this.detailDevisCommande.id);
        this.openPopUpDecloture = false;
        loadingComponent.close();
        messageSucces(this.$i18n.t('detailCommande.popUpDeCloture.success'));
        this.$router.go(0);
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    openPopUpSansSuite() {
      this.isErrorPopup = false;
      this.messagesPopup = [];
      this.popUpSansSuite = true;
    },
    async classerSansSuite() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await sansSuite(this.devisCommande.id);
        this.popUpSansSuite = false;
        this.$router.push({
          name: 'c.bodac.commandes-sansSuite',
          params: {
            id: this.devisCommande.id,
            displayToastClasserSansSuite: true,
          },
        });
        return loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.isErrorPopup = true;
          validationSansSuite(e.response, this.messagesPopup, devisConf.TYPE_COMMANDE);
          validationAnnulationCommission(e.response, this.messagesPopup);
          return loadingComponent.close();
        }
        messageErreur(this.$i18n);
        return loadingComponent.close();
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        if (!donnees.parametresAdditionnels) {
          donnees.parametresAdditionnels = {
            societeId: this.devisCommande.societeId,
          };
        } else donnees.parametresAdditionnels.societeId = this.devisCommande.societeId;
        const response = await edition({
          ids: [this.detailDevisCommande.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: {
            ...(donnees.typeDonnee === TYPE_DONNEE_DIAPORAMA && { isCBA: true }),
            ...(donnees.parametresAdditionnels ?? {}),
          },
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationDevisCommande({ data: response },
            this.errorEdition.messages,
            null,
            devisConf.TYPE_COMMANDE);
          validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
            this.errorEdition.messages, this.errorEdition.messagesChampsVide, translate);
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async changeEtatEnAttente(id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await retourEnAttente(id);
        loadingComponent.close();
        messageSucces(this.$t('renouvellementCommande.changeEtatSucess'));
        this.$router.go(0);
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async marquerRenouveleReconduit(ids, etatRenouvellement) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const message = await renouvellementReconduction
          .marquerCommandeRenouveleeReconduite(ids, etatRenouvellement);
        loadingComponent.close();
        messageSucces(message);
        this.$router.go(0);
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    onNewPayeurSelected(index) {
      this.payeurSelected = this.detailDevisCommande.payeurs[index];
    },
    rechargementSuiteSuppression() {
      this.$router.push({ name: 'l.bodac.commandes-liste' });
    },
    onClickFacture() {
      this.isComponentselectionEcheance = !this.isComponentselectionEcheance;
    },
    onClickCloture() {
      this.messagesPopup = [];
      this.isErrorPopup = false;
      this.showPopupCloture = !this.showPopupCloture;
    },
    async cloture(dateCloture) {
      const loadingComponent = this.$buefy.loading.open();
      this.messagesPopup = [];
      try {
        await cloture(this.devisCommande.id, formatDate(dateCloture));
        this.showPopupCloture = false;
        this.$router.push({
          name: 'c.bodac.commandes-cloture',
          params: {
            id: this.devisCommande.id,
            displayToastCloture: true,
          },
        });
        return loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.isErrorPopup = true;
          validationCloture(e.response, this.messagesPopup, devisConf.TYPE_COMMANDE);
          return loadingComponent.close();
        }
        messageErreur(this.$i18n);
        return loadingComponent.close();
      }
    },
    async getAllDemandeLogistiqueAsync() {
      if (this.detailDevisCommande.lignesCommande.length === 0) return;
      let idsLigneCommande = this.detailDevisCommande.lignesCommande.map(l => l.id);
      this.detailDevisCommande.lignesCommande
        .filter(ligne => ligne.lignesCommande)
        .forEach(ligne => {
          idsLigneCommande = idsLigneCommande.concat(ligne.lignesCommande.map(l => l.id));
        });
      const param = {
        query: {
          ligneCommandeIds: idsLigneCommande,
          societeId: this.societeActiveId,
          types: [
            interventionConf.INTERVENTION_TYPE_INTERVENTION,
            interventionConf.INTERVENTION_TYPE_AFFICHAGE,
            interventionConf.INTERVENTION_TYPE_NON_DEFINI,
          ],
        },
        limit: NO_PAGINATION,
      };
      const result = (await getAll(param)).data.result.items;
      this.detailDevisCommande.lignesCommande.forEach(l => {
        let idsLignes = [l.id];
        if (l.lignesCommande) {
          idsLignes = idsLignes.concat(l.lignesCommande.map(le => le.id));
        }
        const demandes = result.filter(d => idsLignes.includes(d.ligneCommandeId));
        if (demandes) {
          l.demandesLogistique = demandes;
        }
      });
    },
    async getAllOtTechniques() {
      const produits = this.detailDevisCommande.lignesCommande
        .filter((l) => {
          return l.typeProduit === CATEGORIE_UNITAIRE
            && l.produit.produitFace;
        }).map(p => p.produit.produitFace);
      if (produits.length === 0) return;
      const param = {
        query: {
          facesId: produits.filter((p) => {
            return p.faceId !== null;
          }).map(p => p.faceId),
          societeId: this.societeActiveId,
          agencesId: this.agencesSelectionnees.map(agence => agence.agenceId),
        },
        limit: NO_PAGINATION,
      };
      const result = (await getAllOtTechnique(param)).data.result;
      if (result) {
        this.detailDevisCommande.lignesCommande.forEach(l => {
          if (l.typeProduit === CATEGORIE_UNITAIRE && l.produit.produitFace) {
            const otPatrimoines = result.items.filter((ot) => {
              return ot.otPatrimoine;
            });
            const otTechniques = otPatrimoines.filter((ot) => {
              return ot.otPatrimoine.faceId
                && ot.otPatrimoine.faceId === l.produit.produitFace.faceId;
            });
            l.otTechniques = otTechniques;
          }
        });
      }
    },
    async loadCommandeAchat() {
      if (!siteHasHolding()) return;
      const societe = this.societesInformations.find((s) => s.id === this.devisCommande.societeId);
      if (!societe) return;
      this.commandesAchat = await loadCommandeAchatVenteInterne(
        this.devisCommande, societe.listeSocieteTiers,
      );
      const promises = [];
      this.commandesAchat
        .filter(commandeAchat => commandeAchat.commandeVenteInterne != null)
        .forEach(commandeAchat => {
          promises.push(getOdresTravailsOfCommande(commandeAchat.commandeVenteInterne.id));
        });
      const ots = await Promise.all(promises);
      ots.forEach(ot => {
        this.ordresTravails = this.ordresTravails.concat(ot.data.result);
      });
    },
    async load() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.setAttachmentContext({ module: 'Commande' });
        const devisCommande = (await get(this.$route.params.id)).data.result;
        await this.setAttachmentElementId({ id: devisCommande.id });
        await this.loadParametres([
          PARAMETRES_KEYS.categorieGroupeProduitDeductible,
          PARAMETRES_KEYS.regleFacturation,
        ]);
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.modulePresse.key,
          PARAMETRES_INTERNE_KEYS.signatureElectronique.key,
          PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key,
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
          PARAMETRES_INTERNE_KEYS.moduleAchat.key,
          PARAMETRES_INTERNE_KEYS.diaporamaCBA.key,
          PARAMETRES_INTERNE_KEYS.dimensionExportDcfCbaSpe.key,
        ]);
        await this.loadParametreUtilisateur();
        this.ordresTravails = (await getOdresTravailsOfCommande(this.$route.params.id)).data.result;
        await updateInfoLogistiqueLigneCmd(devisCommande);
        devisCommande.etatSuivis.forEach((item) => {
          if (item.date) item.date = new Date(item.date);
        });
        if (devisCommande.dateTransmissionAuClub) {
          devisCommande.dateTransmissionAuClub = new Date(devisCommande.dateTransmissionAuClub);
        }
        if (devisCommande.dateTransmissionAuClient) {
          devisCommande.dateTransmissionAuClient = new Date(devisCommande.dateTransmissionAuClient);
        }
        this.devisCommande = devisCommande;
        await this.loadCommandeAchat();
        if (this.moduleSignatureElectroniqueActive) {
          this.devisCommande.signaturesHisto = (await getAllSignatures({
            query: {
              referenceId: this.devisCommande.id,
              societeId: this.societeActiveId,
            },
            MaxResultCount: NO_PAGINATION,
            SkipCount: 0,
          })).data.result.items;
          this.toolTipSignatureInfo = getInfosSignaturePourDevisCommande(
            this.devisCommande.signaturesHisto);
        }
        this.commandASupp.push(this.devisCommande);
        this.detailDevisCommande = detailDevisCommande(this.devisCommande);
        this.payeurSelected = this.detailDevisCommande.payeurs[0];
        if (this.$route.params.displayToastClasserSansSuite) {
          snackBarSuccess(
            this.$i18n.t('detail.validation.commandeSansSuiteSuccess'),
            this.devisCommande.referenceId
              ? this.$i18n.t('detailCommande.actions.goDevis') : null,
            this.devisCommande.referenceId ? () => {
              this.$router.push({
                name: 'c.bodac.devis',
                params: { id: this.devisCommande.referenceId },
              });
            } : null,
          );
        }
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
      this.$bus.$on('new-payeur-selected', this.onNewPayeurSelected);
    },
    async closeBillWithReload() {
      this.isComponentselectionEcheance = false;
      await this.load();
      if (this.activeTab === 'AppDetailCommande') this.$refs.loadFromChild.loadFilArianne();
      messageSucces(this.$t('facturationCommande.facturationCommandeZero'));
      await this.$router.go(0);
    },
    copy(newDateCmd) {
      this.setCommandeCourant(genererCopyDevisCommande(this.devisCommande, newDateCmd));
      this.$router.push({ name: 'm.bodac.commandes-ajout' });
    },
    async getListeFacePourUneLigneReseau(ligne) {
      let listeFacePourReseau = await getLignesSelectionFace(ligne, false, this.users,
        ligne.produit.supportCommercial.societeId);
      if (ligne.ligneReseau.lignesCmdSelProduits.length !== 0) {
        listeFacePourReseau = listeFacePourReseau.filter(elt => { return elt.selected; });
      }
      const objetRetour = {};
      objetRetour.ligneVente = ligne;
      objetRetour.listeFace = listeFacePourReseau;
      return objetRetour;
    },
    async exporterListeFacesVenduesReseauTempo() {
      const loadingComponent = this.$buefy.loading.open();
      const listeLigneCommandeReseau = this.devisCommande.lignesCommande.filter((ligne) => {
        return ligne.typeProduit === CATEGORIE_REGROUPEMENT;
      });
      const promiseListeProduitReseau = [];
      for (let i = 0; i < listeLigneCommandeReseau.length; i += 1) {
        const ligne = listeLigneCommandeReseau[i];
        const dateVisualisation = getDateWithAnneeSemaineAndJourDepart(
          ligne.ligneReseau.anneeSemaine, ligne.ligneReseau.jourDepart,
        );
        promiseListeProduitReseau.push(
          this.getListeFacePourUneLigneReseau(ligne, dateVisualisation),
        );
      }
      const listeProduitReseau = (await Promise.all(promiseListeProduitReseau));
      exportListeFaceVenduInCommandeTempo(
        listeProduitReseau, i18n, this.paramDimensionExportDcfCbaSpe);
      loadingComponent.close();
    },
    async exporterLigneVente() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel(this.exportExcelQuery);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        if (this.errorManager) this.errorManager(e);
        else messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
    async closeDemandeSignature() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.isError = false;
        await stopActionSignature(this.devisCommande.id);
        loadingComponent.close();
        messageSucces(this.$t('detail.validation.closeDemandeSignatureSucces'));
        this.$router.go(0);
        return;
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.isError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async reinitialiserIndexation() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulationIndexation({
          CommandeIds: [this.devisCommande.id],
        });
        messageSucces(this.$t('detailCommande.resetIndexation.messageResetSuccess'));
        await this.load();
      } catch (e) {
        if (e.response.data.error) {
          validationIndexation(e.response, this.messages);
          this.isError = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    await this.load();
    if (this.devisCommande.interne === true) {
      const routeName = this.devisCommande.sens === devisConf.SENS_VENTE ? 'c.bodac.commandes-venteInterne' : 'c.bodac.commandes-achatVenteInterne';
      await this.$router.push({ name: routeName, params: { id: this.devisCommande.id } });
      return;
    }
    await this.getAllDemandeLogistiqueAsync();
    if (this.moduleLogistiqueTechnique) {
      await this.getAllOtTechniques();
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.detailDevisCommande.code }));
  },
  destroyed() {
    this.$bus.$off('new-payeur-selected', this.onNewPayeurSelected);
  },
};
</script>
